var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['jump-header']},[_vm._m(0),_c('div',{staticClass:"open-app",on:{"click":_vm.downloadApp}},[_vm._v("打开APP")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left"},[_c('img',{attrs:{"src":require("@/assets/image/icon_logo.png"),"alt":""}}),_c('span',[_vm._v("花城+")])])
}]

export { render, staticRenderFns }